<template>
  <div class="t_tabbar">
    <van-tabbar route>
      <van-tabbar-item
        v-for="(item, key) in TabbarList"
        :class="{'noPath': !item.path}"
        :key="key"
        :to="item.path"
        :icon="item.icon"
      >
        <!-- <svg
          slot="icon"
          :class="['icon','svg-icon',{'selected_icon':$route.path === item.path}]"
          aria-hidden="true"
        >
          <use :xlink:href="item.icon" />
        </svg>-->
        {{item.title}}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  name: 'TTabbar',
  components: {
  },
  props: {
    currentPath: {
      type: String
    }
  },
  data() {
    return {
      TabbarList: [
        {
          path: '/',
          // icon: '#icon-tabbar_workbench',
          icon: 'home-o',
          title: '工作台'
        },
        {
          path: '/userCenter',
          // icon: '#icon-tabbar_me',
          icon: 'friends-o',
          title: '我的'
        }
      ]
    }
  }
}
</script>
<style lang="scss">
@import "../../../assets/css/variables.scss";
.t_tabbar {
  background: $mainBgColor;
  .van-tabbar {
    background: $mainBgColor;
  }
  .noPath {
    pointer-events: none;
  }
  .van-tabbar-item--active {
    color: #355db4;
  }
  
 .van-tabbar-item--active {
    font-weight: 800;
    color: #355db4;
    .van-icon {
      position: relative;
      display: inline-block;
      font: normal normal normal 3.733vw / 1 vant-icon;
      font-size: inherit;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      font-weight: 800;
  }
}
}
</style>
